import { render, staticRenderFns } from "./ColegiadoShow.vue?vue&type=template&id=d25a74e8&scoped=true&"
import script from "./ColegiadoShow.vue?vue&type=script&lang=js&"
export * from "./ColegiadoShow.vue?vue&type=script&lang=js&"
import style0 from "./ColegiadoShow.vue?vue&type=style&index=0&id=d25a74e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25a74e8",
  null
  
)

export default component.exports